/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelPaymentAuthorizationRequest
 */
export interface CancelPaymentAuthorizationRequest {
    /**
     * Stripe PaymentIntent id (`pi_xxx`) whose uncaptured authorization should be cancelled.
     * @type {string}
     * @memberof CancelPaymentAuthorizationRequest
     */
    paymentIntentId: string;
    /**
     * Optional Gondola booking id — attached to logs for traceability.
     * @type {string}
     * @memberof CancelPaymentAuthorizationRequest
     */
    bookingId?: string | null;
    /**
     * Route to STRIPE_SECRET_KEY_TEST instead of the live key.
     * @type {boolean}
     * @memberof CancelPaymentAuthorizationRequest
     */
    test?: boolean;
}

/**
 * Check if a given object implements the CancelPaymentAuthorizationRequest interface.
 */
export function instanceOfCancelPaymentAuthorizationRequest(value: object): value is CancelPaymentAuthorizationRequest {
    if (!('paymentIntentId' in value) || value['paymentIntentId'] === undefined) return false;
    return true;
}

export function CancelPaymentAuthorizationRequestFromJSON(json: any): CancelPaymentAuthorizationRequest {
    return CancelPaymentAuthorizationRequestFromJSONTyped(json, false);
}

export function CancelPaymentAuthorizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelPaymentAuthorizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'test': json['test'] == null ? undefined : json['test'],
    };
}

export function CancelPaymentAuthorizationRequestToJSON(json: any): CancelPaymentAuthorizationRequest {
    return CancelPaymentAuthorizationRequestToJSONTyped(json, false);
}

export function CancelPaymentAuthorizationRequestToJSONTyped(value?: CancelPaymentAuthorizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'booking_id': value['bookingId'],
        'test': value['test'],
    };
}

